export const FEATURE_FLAGS = {
  LAB_ORDERS_ENABLED: import.meta.env.VITE_APP_IS_LAB_ORDERS_ENABLED_FEATURE_FLAG === 'true',
  RADIOLOGY_ENABLED: import.meta.env.VITE_APP_IS_RADIOLOGY_ENABLED_FEATURE_FLAG === 'true',
  IN_HOUSE_LABS_ENABLED: import.meta.env.VITE_APP_IS_IN_HOUSE_LABS_ENABLED_FEATURE_FLAG === 'true',
  NURSING_ORDERS_ENABLED: import.meta.env.VITE_APP_IS_NURSING_ORDERS_ENABLED_FEATURE_FLAG === 'true',
  SUPERVISOR_APPROVAL_ENABLED: import.meta.env.VITE_APP_IS_SUPERVISOR_APPROVAL_ENABLED_FEATURE_FLAG === 'true',
  DEMO_VISITS_ENABLED: import.meta.env.VITE_APP_CREATE_DEMO_VISITS_FEATURE_FLAG === 'true',
  GLOBAL_TEMPLATES_ENABLED: import.meta.env.VITE_APP_IS_GLOBAL_TEMPLATES_ENABLED_FEATURE_FLAG === 'true',
};
